// extracted by mini-css-extract-plugin
module.exports = {"split":"ClientInfo_split__7cSLx","column":"ClientInfo_column__2VaHQ"};